import { Component, OnInit, AfterViewInit } from '@angular/core';
import { AuthService } from 'src/app/shared/route-guards/services/auth.service';
import {
  DVFormGroup,
  DVFormControl
} from 'src/app/shared/helpers/dynamic-validators/dynamic-validator';
import { Validators } from '@angular/forms';
import { SnotifyService } from 'ng-snotify';
import { AuthenticationService } from '../authentication.service';
declare var $;
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit, AfterViewInit {
  loginForm: DVFormGroup;
  recoverForm: DVFormGroup;
  incorrectMessageVisible = false;
  constructor(
    private authService: AuthService,
    private authApi: AuthenticationService,
    private notifier: SnotifyService
  ) {}

  ngOnInit() {
    this.loginForm = new DVFormGroup({
      email: new DVFormControl(null, {
        'Email is required': Validators.required,
        'Email is not in a valid format': Validators.email
      }),
      password: new DVFormControl(null, {
        'Password is required': Validators.required
      })
    });
    this.recoverForm = new DVFormGroup({
      email: new DVFormControl(null, {
        'Email is required': Validators.required,
        'Email is not in a valid format': Validators.email
      })
    });
  }
  ngAfterViewInit() {
    $(`[data-toggle='tooltip']`).tooltip();
    $('.preloader').fadeOut();
    $('#to-recover').on('click', function() {
      $('#loginform').slideUp();
      $('#recoverform').fadeIn();
    });
  }

  async formSubmit() {
    if (this.loginForm.invalid) {
      return this.loginForm.forceShowErrors();
    }

    try {
      const response = await this.authApi
        .login(this.loginForm.value)
        .toPromise();
      this.authService.login(response.data.token, response.data.user, response.data.role);
      this.notifier.success('Login Success');
    } catch (err) {
      // console.log(err)
      this.notifier.error(err.error.message);
      this.incorrectMessageVisible = true;
    }
  }
  async recoverPassword() {
    if (this.recoverForm.valid) {
      try {
        const response = await this.authApi
          .forgetPassword(this.recoverForm.value)
          .toPromise();
        $('#to-login').click(function() {
          $('#recoverform').hide();
          $('#loginform').fadeIn();
        });
        this.notifier.success('Reset Email Sent Successfully');
      } catch (err) {
        this.notifier.error(err);
        this.incorrectMessageVisible = true;
      }
    } else {
      this.recoverForm.forceShowErrors();
    }
  }
  backToLogin() {
    $('#to-login').click(function() {
      $('#recoverform').hide();
      $('#loginform').fadeIn();
    });
  }
}
